import { render, staticRenderFns } from "./ValidationInput.vue?vue&type=template&id=70ca3b85&scoped=true&"
import script from "./ValidationInput.vue?vue&type=script&lang=js&"
export * from "./ValidationInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ca3b85",
  null
  
)

export default component.exports